import { IPasstObtjetivoModel } from "../interfaces/passt/IPasstObtjetivoModel";

export class PasstObtjetivoModel implements IPasstObtjetivoModel{
    idPasstObjetivo:number;
    idPasst:number;
    objetivo?:string;
    meta?:string;
    indicador?:string;
    presupuesto?:string;
    recurso?:string;       
    index: number;  

    constructor(){
        this.idPasstObjetivo=0;    
        this.idPasst=0;
        this.index = 0;
    }
}